import { createSelector } from 'reselect';

import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { filter, flatMap, orderBy, union, uniq } from 'es-toolkit/compat';
import isScheduledInventoryConfig from 'selectors/isScheduledInventoryConfig';
import serviceTypesSelector from 'selectors/serviceTypesSelector';

const serviceOrderMapping: { [service: string]: number } = {
  BREAKFAST: 1,
  BRUNCH: 2,
  LUNCH: 3,
  DINNER: 4,
};

/**
 * Returns a list of service types from a union of
 * 1. Active experiences services
 * 2. Configured day of week hours services
 * Handles case where restuarant does not set accurate hours,
 * but this may be changed when restaurants have control over public vs private hours.
 *
 * For TACO businesses, we take only service type information, because for these
 * businesses the list of services on the experience proto is not reliable.
 */
export default createSelector(
  (state: StoreType) => state.tickets.list.ticketTypes,
  serviceTypesSelector,
  isScheduledInventoryConfig,
  (
    experiences: core.TicketType[],
    hoursServiceTypes: core.Service.Type[],
    isScheduledInventory: boolean
  ): core.Service.Type[] => {
    if (isScheduledInventory) {
      return hoursServiceTypes;
    } else {
      const activeExperiences = filter(experiences, (experience) => !experience.isArchived);
      const experienceServicesUnordered = uniq(
        flatMap(activeExperiences, (experience) => experience.serviceType)
      );

      const experienceAndHoursServices = union(experienceServicesUnordered, hoursServiceTypes);

      return orderBy(experienceAndHoursServices, (service) => {
        return serviceOrderMapping[service];
      });
    }
  }
);
